/* AI Cart Companion — Luxury Editorial v8.2 */
(function(){
  let STARTED=false; const productCache=new Map(); let _eqTimer=null;
  const $=(s,r=document)=>r.querySelector(s); const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const isMobile=()=>window.matchMedia('(max-width:640px)').matches;

  function getCurrency(){ try{ return Shopify?.currency?.active || Shopify?.currency || 'USD'; }catch{ return 'USD'; } }
  const normalizeUrl=u=>{ if(!u) return ''; let out=String(u).trim(); if(!out) return ''; if(out.startsWith('//')) out='https:'+out; else if(out.startsWith('/')) out=location.origin+out; return out; };
  const fmtMoney=(c,curr)=>{ const v=(c||0)/100; try{ return new Intl.NumberFormat(undefined,{style:'currency',currency:curr||getCurrency()}).format(v);}catch{ return `$${v.toFixed(2)}`;} };
  const toCents=v=>typeof v==='number'?Math.round(v):Math.round((parseFloat(v)||0)*100);
  const cleanText=h=>String(h||'').replace(/\/\*[\s\S]*?\*\//g,'').replace(/#sa-scope[^\s]*/gi,'').replace(/<style[\s\S]*?<\/style>/gi,'').replace(/<script[\s\S]*?<\/script>/gi,'').replace(/<[^>]+>/g,'').replace(/\s+/g,' ').trim();
  const shortDesc=t=>{const s=cleanText(t||'');return s.length>120?s.slice(0,117)+'…':s;};

  function equalize(){ if(isMobile()) return; const root=$('#sa-ai-cart-companion'); if(!root) return;
    const cards=$$('.sa-card',root); if(!cards.length) return; cards.forEach(c=>c.style.minHeight='');
    const rows=new Map(); cards.forEach(c=>{ const t=Math.round(c.getBoundingClientRect().top); if(!rows.has(t)) rows.set(t,[]); rows.get(t).push(c); });
    rows.forEach(g=>{ const max=Math.max(...g.map(c=>c.offsetHeight)); g.forEach(c=>c.style.minHeight=max+'px'); });
  }
  const schedule=(d=120)=>{ clearTimeout(_eqTimer); _eqTimer=setTimeout(equalize,d); };
  addEventListener('resize',()=>schedule(140));

  function pickImage(p){ const maybe=[]; const push=v=>{ if(!v) return; if(typeof v==='string') maybe.push(v); else if(typeof v==='object'){ for(const k of ['src','url','preview_image','originalSrc','currentSrc']) if(v[k]) maybe.push(v[k]); } };
    push(p?.image); push(p?.featured_image); push(p?.featuredMedia); push(p?.featured_media);
    if(Array.isArray(p?.images)&&p.images[0]) push(p.images[0]); if(Array.isArray(p?.media)&&p.media[0]) push(p.media[0]);
    push(p?.image_url); push(p?.img); push(p?.photo); push(p?.picture); push(p?.thumbnail); push(p?.thumb);
    return normalizeUrl(maybe.find(Boolean)||''); }

  async function fetchProductJson(handle){
    if(!handle) return null; if(productCache.has(handle)) return productCache.get(handle);
    try{ const r=await fetch(`/products/${handle}.js`,{credentials:'same-origin'}); if(r.ok){ const pj=await r.json(); productCache.set(handle,pj); return pj; } }catch(_){}
    return null;
  }

  function getRoot(){ return document.getElementById('sa-ai-cart-companion'); }
  const first=getRoot();
  if(!first){ const mo=new MutationObserver(()=>{ const r=getRoot(); if(r && !STARTED){ mo.disconnect(); start(r); } }); mo.observe(document.documentElement,{childList:true,subtree:true}); }
  else start(first);

  function start(root){
    if(STARTED) return; STARTED=true;

    const ENDPOINT=(root.getAttribute('data-endpoint')||'https://ai-cart-assist.l-alamzeb.workers.dev/ai/cart-assist').trim();
    const cfg={ endpoint:ENDPOINT, max:parseInt(root.dataset.max||'2',10), timeout:parseInt(root.dataset.timeout||'5000',10) };

    let typing,msg,cards,actions;

    root.innerHTML=`
      <div class="sa-ai-stage">
        <div class="sa-ai-shell">
          <div class="sa-ai-avatar" aria-hidden="true">SA</div>
          <div class="sa-ai-body">
            <div class="sa-ai-typing" hidden><span class="sa-dot"></span><span class="sa-dot"></span><span class="sa-dot"></span></div>
            <div class="sa-ai-msg" hidden></div>
            <div class="sa-ai-cards" hidden></div>
            <div class="sa-ai-actions" hidden>
              <button type="button" class="sa-btn sa-btn-secondary" data-sa-skip>Not now</button>
            </div>
          </div>
        </div>
      </div>`;
    typing=$('.sa-ai-typing',root); msg=$('.sa-ai-msg',root); cards=$('.sa-ai-cards',root); actions=$('.sa-ai-actions',root);

    const body=$('.sa-ai-body',root);
    const head=document.createElement('div'); head.className='sa-ai-head'; body.insertBefore(head,body.firstChild);
    head.appendChild(typing); head.appendChild(msg); actions.classList.add('in-row'); head.appendChild(actions);

    const stopTyping=()=>{ typing.hidden=true; typing.style.display='none'; typing.setAttribute('aria-hidden','true'); };

    async function getCart(){ const r=await fetch('/cart.js',{credentials:'same-origin'}); return r.json(); }

    /* Build mobile-first variants: only Color + Size. */
    function buildVariantUI(card,variants,options,initialImgUrl){
      const optsWrap=$('.sa-opts',card), cta=$('[data-sa-add]',card), price=$('.sa-price-pill',card);
      const img=$('.sa-img',card), imgWrap=$('.sa-card-img',card);
      const ensureImg=u=>{ const x=normalizeUrl(u||initialImgUrl); if(!x) return; img.addEventListener('load',()=>imgWrap.classList.add('is-ready'),{once:true}); img.src=x; };

      if(!Array.isArray(variants)||!variants.length){ optsWrap.hidden=true; ensureImg(initialImgUrl); return; }

      const optDefs=(options||[]).map(o=>({name:String(o?.name||'Option').trim(),values:Array.from(new Set(o?.values||[]))}));
      if(optDefs.length===0){
        const f=variants[0]; if(f&&(f.option1||f.option2||f.option3)){
          const names=['Option1','Option2','Option3']; const vals=[f.option1,f.option2,f.option3].filter(Boolean);
          for(let i=0;i<vals.length;i++) optDefs.push({name:names[i],values:[vals[i]]});
        }
      }

      const colorIdx=optDefs.findIndex(o=>/color|colour/i.test(o.name));
      const sizeIdx =optDefs.findIndex(o=>/size/i.test(o.name));

      const sel={0:null,1:null,2:null};
      const variantForSel=()=>variants.find(v=>{ const o=[v.option1,v.option2,v.option3]; for(let i=0;i<3;i++){ if(sel[i] && o[i]!==sel[i]) return false; } return true; })||null;

      function setCTA(v){
        if(v && v.available!==false){
          cta.disabled=false; cta.setAttribute('data-sa-add',v.id);
          price.textContent=fmtMoney(v.price,getCurrency());
          if(v.featured_image?.src) ensureImg(v.featured_image.src); else ensureImg(initialImgUrl);
        }else{ cta.disabled=true; cta.removeAttribute('data-sa-add'); }
      }
      function updateCTA(){ setCTA( variantForSel() || variants.find(x=>x.available!==false) || variants[0] ); }

      function row(idx,def){
        const r=document.createElement('div'); r.className='sa-opt-row';
        const label=document.createElement('div'); label.className='sa-opt-label'; label.textContent=def.name; r.appendChild(label);
        const isColor=/color|colour/i.test(def.name);
        (def.values||[]).forEach(val=>{
          const b=document.createElement('button'); b.type='button'; b.setAttribute('data-opt-idx',String(idx)); b.setAttribute('data-opt-val',String(val));
          b.className=isColor?'sa-swatch':'sa-size'; if(isColor) b.style=colorChipStyle(val); else b.textContent=val;

          const probe=Object.assign({},sel,{[idx]:val});
          const possible=variants.some(v=>{ const o=[v.option1,v.option2,v.option3]; for(let i=0;i<3;i++){ if(probe[i] && o[i]!==probe[i]) return false; } return v.available!==false; });
          if(!possible) b.disabled=true;

          b.addEventListener('click',()=>{ if(b.disabled) return; sel[idx]=val; $$('.sa-swatch,.sa-size',r).forEach(x=>x.classList.toggle('is-selected',x===b)); updateCTA(); });
          r.appendChild(b);
        });
        return r;
      }

      /* Only Color + Size on mobile; desktop can render all (but we keep it simple). */
      const order=[]; if(colorIdx>=0) order.push(colorIdx); if(sizeIdx>=0) order.push(sizeIdx);
      if(!isMobile()){ for(let i=0;i<optDefs.length;i++) if(!order.includes(i)) order.push(i); }

      optsWrap.innerHTML=''; order.forEach(i=>optsWrap.appendChild(row(i,optDefs[i]))); optsWrap.hidden=false;

      /* auto-select one-value options */
      order.forEach(i=>{ const vals=optDefs[i]?.values||[]; if(vals.length===1){ sel[i]=vals[0]; const only=$$('[data-opt-idx="'+i+'"]',optsWrap)[0]; if(only) only.classList.add('is-selected'); } });

      ensureImg(initialImgUrl); updateCTA();
    }

    function colorChipStyle(v){
      v=String(v||'').toLowerCase().trim();
      const named={black:'#000',white:'#fff',ivory:'#fffff0',cream:'#f6efe5',red:'#e11900',burgundy:'#6b0b28',wine:'#6b0b28',pink:'#ff5fa2',blush:'#f6c1c8',nude:'#e9d5c5',beige:'#e7d9c6',brown:'#7a4b2e',tan:'#d2b48c',orange:'#ff7a00',coral:'#ff7f6e',yellow:'#ffd400',gold:'#d4af37',brass:'#b5a642',lime:'#bfff00',green:'#0b8f5a',mint:'#98ff98',teal:'#157a6e',cyan:'#00bcd4',blue:'#2b6cb0',navy:'#0b2545',purple:'#6b46c1',lavender:'#b57edc',lilac:'#c8a2c8',silver:'#c0c0c0',grey:'#9aa0a6'};
      let bg=named[v] || (/#([0-9a-f]{3}|[0-9a-f]{6})/.test(v)?v:null); if(!bg) bg='linear-gradient(135deg,#f0f0f0,#d9d9e3)'; return `background:${bg}`;
    }

    function renderCards(products){
      if(!cards) return false;
      const picks=(products||[]).slice(0,cfg.max);
      if(!picks.length){ cards.hidden=true; return false; }

      cards.innerHTML=picks.map(p=>{
        const title=String(p.title||'Suggested item');
        const url=p.url || (p.handle?`/products/${p.handle}`:'#');
        const price=fmtMoney(toCents(p.price_cents ?? p.price ?? p.price_min ?? 0), p.currency);
        const vid=p?.variants?.[0]?.id || p?.variant_id || '';
        const desc=shortDesc(p?.description || p?.body_html || p?.body || '');
        return `
          <article class="sa-card" data-default-vid="${vid||''}" data-handle="${p.handle||''}">
            <a href="${url}" class="sa-card-img" aria-label="${title}">
              <img class="sa-img" alt="${(title||'').replace(/"/g,'&quot;')}">
              <span class="sa-price-pill">${price}</span>
            </a>
            <div class="sa-card-info">
              <div class="sa-card-title">${title.replace(/</g,'&lt;')}</div>
              <div class="sa-card-desc">${desc.replace(/</g,'&lt;')}</div>
              <div class="sa-opts" hidden></div>
              <div class="sa-card-cta">
                <button type="button" class="sa-btn" data-sa-add="${vid}" ${vid?'':'disabled'}>Add to cart</button>
              </div>
            </div>
          </article>`;
      }).join('');
      cards.hidden=false;

      hydrate(cards,picks);
      schedule(60);
      return true;
    }

    function hydrate(scope,raw){
      $$('.sa-card',scope).forEach(async (card,idx)=>{
        const wrap=$('.sa-card-img',card), imgEl=$('.sa-img',card);
        const handle=card.getAttribute('data-handle') || raw?.[idx]?.handle || '';
        let initial=pickImage(raw?.[idx]||'');

        const ensure=async ()=>{
          let variants=Array.isArray(raw?.[idx]?.variants)?raw[idx].variants:null;
          let options =Array.isArray(raw?.[idx]?.options) ?raw[idx].options :null;
          const descEl=$('.sa-card-desc',card);

          const pj=handle?await fetchProductJson(handle):null;
          if(pj){
            if(!initial && Array.isArray(pj.images) && pj.images[0]) initial=pj.images[0];
            variants=pj.variants; options=pj.options;
            if(descEl && !descEl.textContent.trim()) descEl.textContent=shortDesc(pj?.description || pj?.body_html || '');
          }

          if(initial){ imgEl.addEventListener('load',()=>{wrap.classList.add('is-ready');schedule(50);},{once:true}); imgEl.src=normalizeUrl(initial); }
          if(variants && variants.length){ buildVariantUI(card,variants,options,initial); }
        };
        ensure();
      });

      scope.addEventListener('click', async e=>{
        const btn=e.target.closest('[data-sa-add]'); if(!btn) return;
        const vid=btn.getAttribute('data-sa-add'); if(!vid) return;
        await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:1})});
        btn.textContent='Added ✓'; btn.classList.add('sa-btn-success'); document.dispatchEvent(new CustomEvent('sa:cart:refresh'));
      });
    }

    async function nudge(){
      const r=await getCart(); if(!r?.items?.length) return;

      const snapshot={ currency:getCurrency(), total_price:r.total_price,
        items:(r.items||[]).map(it=>({ title:it.product_title, handle:it.handle, product_type:it.product_type,
          tags:it.tags||[], quantity:it.quantity, price:it.final_line_price || it.line_price || 0,
          options:(it.options_with_values||[]).map(ov=>({name:ov.name,value:ov.value})) })) };

      typing.hidden=false; msg.hidden=true; cards.hidden=true; actions.hidden=true;

      let out=null;
      try{
        const controller=new AbortController(); const t=setTimeout(()=>controller.abort(),cfg.timeout);
        const res=await fetch(cfg.endpoint,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          credentials:'same-origin',body:JSON.stringify(snapshot),signal:controller.signal});
        clearTimeout(t); if(res.ok) out=await res.json();
      }catch(e){ console.warn('[AI Cart] error',e); }

      typing.hidden=true; typing.style.display='none'; typing.setAttribute('aria-hidden','true');
      if(!out) return;

      const text=(typeof out.message==='string'?out.message.trim():'') || 'Curated picks from our AI stylist.';
      msg.textContent=text; msg.hidden=false; actions.hidden=false;

      renderCards(Array.isArray(out.products)?out.products:[]);
    }

    actions?.querySelector?.('[data-sa-skip]')?.addEventListener('click',()=>{ const mount=root; mount.style.display='none'; setTimeout(()=>{ mount.style.display=''; },60000); });

    const origFetch=window.fetch;
    window.fetch=function(input,init){
      const url=(typeof input==='string')?input:input?.url;
      const isCartOp=url && (/\/cart\/(add|change|update)\.js/.test(url));
      return origFetch.apply(this,arguments).then(async resp=>{ if(isCartOp) setTimeout(nudge,150); return resp; });
    };

    document.addEventListener('DOMContentLoaded',()=>setTimeout(nudge,350));
  }

  (function mountOnCartPage(){
    const isCart=/((^|\/)cart(\/|$|\?|#))/i.test(location.pathname+location.search)||
      document.querySelector('form[action="/cart"]')||
      document.querySelector('button[name="checkout"], [href="/checkout"]')||
      document.querySelector('[data-cart], [data-cart-root], [data-section-type="cart"]');
    if(!isCart) return;

    const targets=['#main-cart-footer','.cart__footer','form[action="/cart"] .cart__footer','form[action="/cart"]',
      '.cart__ctas','.totals','.cart__blocks','.cart__footer-wrapper','[data-cart-footer]',
      '[data-cart-content]','.page-width','main .section','main','.shopify-section'];

    function findHost(){ for(const t of targets){ const el=document.querySelector(t); if(el) return el; }
      const cta=document.querySelector('button[name="checkout"], [href="/checkout"]'); return cta?(cta.parentElement||cta.closest('form')||cta):document.body; }

    function ensureMount(){
      const host=findHost(); if(!host) return false;
      let mount=document.getElementById('sa-ai-cart-companion');
      if(!mount){
        mount=document.createElement('div'); mount.id='sa-ai-cart-companion'; mount.className='sa-ai-companion';
        mount.setAttribute('data-endpoint','https://ai-cart-assist.l-alamzeb.workers.dev/ai/cart-assist');
        mount.setAttribute('data-timeout','5000'); mount.setAttribute('data-max','2');
        host.appendChild(mount);
      }
      if(!STARTED){ const r=document.getElementById('sa-ai-cart-companion'); if(r) start(r); }
      return true;
    }

    if(!ensureMount()){ const mo=new MutationObserver(()=>{ if(ensureMount()) mo.disconnect(); }); mo.observe(document.documentElement,{childList:true,subtree:true}); }
  })();
})();
